/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clipboard_Copy_Successtitle1Inputs */

const en_clipboard_copy_successtitle1 = /** @type {(inputs: Clipboard_Copy_Successtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied to clipboard`)
};

/**
* | output |
* | --- |
* | "Copied to clipboard" |
*
* @param {Clipboard_Copy_Successtitle1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const clipboard_copy_successtitle1 = /** @type {((inputs?: Clipboard_Copy_Successtitle1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clipboard_Copy_Successtitle1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_clipboard_copy_successtitle1(inputs)
});
export { clipboard_copy_successtitle1 as "clipboard_copy_successTitle" }